import * as React from 'react';

export const AuthBackground: React.FC = () => (
  <div aria-hidden className="pointer-events-none absolute inset-0 bg-background" />
);

AuthBackground.displayName = 'AuthBackground';
